module.exports = __webpack_public_path__ + "img/Icon-youtube.4bffb5ce.svg";